<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15"
      cy="13"
      r="4"
      fill="#4D4E58"
      stroke="#4D4E58"
      stroke-width="2"
    />
    <circle
      cx="33"
      cy="18"
      r="4"
      fill="white"
      stroke="#4D4E58"
      stroke-width="2"
    />
    <path
      d="M7 27C7 23.134 10.134 20 14 20H15C18.866 20 22 23.134 22 27V38C22 39.1046 21.1046 40 20 40H9C7.89543 40 7 39.1046 7 38V27Z"
      fill="white"
      stroke="#4D4E58"
      stroke-width="2"
    />
    <path
      d="M25 32C25 28.134 28.134 25 32 25H33C36.866 25 40 28.134 40 32V38C40 39.1046 39.1046 40 38 40H27C25.8954 40 25 39.1046 25 38V32Z"
      fill="white"
      stroke="#4D4E58"
      stroke-width="2"
    />
    <path
      d="M16 34.5C16 30.3579 19.3579 27 23.5 27C27.6421 27 31 30.3579 31 34.5V39H16V34.5Z"
      fill="white"
    />
    <path
      d="M10 26.5C10 23.4624 12.4624 21 15.5 21C18.5376 21 21 23.4624 21 26.5V38C21 38.5523 20.5523 39 20 39H11C10.4477 39 10 38.5523 10 38V26.5Z"
      fill="#E0E5FF"
    />
    <path
      d="M17 38.2727C17 34.8084 19.8084 32 23.2727 32H23.7273C27.1916 32 30 34.8084 30 38.2727C30 39.2267 29.2267 40 28.2727 40H18.7273C17.7733 40 17 39.2267 17 38.2727Z"
      fill="white"
      stroke="#4D4E58"
      stroke-width="2"
    />
    <circle
      cx="24"
      cy="25"
      r="4"
      fill="white"
      stroke="#4D4E58"
      stroke-width="2"
    />
  </svg>
</template>
